import { Injectable } from '@angular/core';
import { Drawer, DrawerOptions, Dropdown, InstanceOptions } from 'flowbite';

@Injectable({
  providedIn: 'root',
})
export class FlowbiteService {



  showDrawer(id: string): void {
    const drawer = (<any>window).FlowbiteInstances._instances.Drawer[id] as Drawer;
    if (drawer) {
      drawer.show();
    } else {
      console.error(`Drawer with id ${id} not found`);
    }
  }

  hideDrawer(id: string): void {
    const drawer = (<any>window).FlowbiteInstances._instances.Drawer[id] as Drawer;
    if (drawer) {
      drawer.hide();
    } else {
      console.error(`Drawer with id ${id} not found`);
    }
  }

  toggleDrawer(id: string): void {
    const drawer = (<any>window).FlowbiteInstances._instances.Drawer[id] as Drawer;
    if (drawer) {
      drawer.toggle();
    } else {
      console.error(`Drawer with id ${id} not found`);
    }
  }

  isDrawerVisible(id: string): boolean {
    const drawer = (<any>window).FlowbiteInstances._instances.Drawer[id] as Drawer;
    return drawer ? drawer.isVisible() : false;
  }

  getAllDrawers() {
    return Object.values(
      (<any>window).FlowbiteInstances._instances.Drawer
    ) as Drawer[];
  }
  hideAllDrawers() {
    const drawers = Object.values(
      (<any>window).FlowbiteInstances._instances.Drawer
    ) as Drawer[];

    drawers.forEach((d) => d.hide());
  }
  hideAllDropdown() {
    const drawers = Object.values(
      (<any>window).FlowbiteInstances._instances.Dropdown
    ) as Dropdown[];

    drawers.forEach((d) => d.hide());
  }
  initTooltips() {
    (<any>window).initTooltips();
  }
  initFlowbite() {
    (<any>window).initFlowbite();
  }
  initDrawers() {
    (<any>window).initDrawers();
  }
  initDatepickers() {
    (<any>window).Flowbite.initDatepickers();
  }
}
